module.exports = __webpack_public_path__ + "dk.svg?59a9d25f6d57f572f48c2c1eeecb0724";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/dk.svg
// module id = 1072
// module chunks = 0